import React from "react";
import Arsi from "@ht/shared/fonts/deos-pis/logo-arsi";
import { icons } from "./icons";

interface Props extends React.SVGProps<SVGSVGElement> {
    name: string;
}

const Icon = ({ name, ...restProps }: Props) => {
    return icons.findIndex((icon) => icon.name === name) > -1 ? (
        icons
            .filter((icon) => icon.name === name)
            .map((icon) => <icon.component key={name} {...restProps} />)[0]
    ) : (
        <Arsi {...restProps} />
    );
};

export default Icon;
